import React from 'react';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const AnimatedSection = ({ 
  children, 
  direction = 'up', 
  delay = 0,
  threshold = 0.3,  // Added threshold prop
  rootMargin = '-50px 0px'  // Added rootMargin prop
}) => {
  const [ref, inView] = useInView({
    threshold,
    rootMargin,
    triggerOnce: true,
  });

  const getAnimationProps = () => {
    const baseProps = {
      opacity: inView ? 1 : 0,
      delay,
      config: { 
        mass: 1, 
        tension: 280, 
        friction: 60,
        duration: 800  // Added duration for smoother animation
      }
    };

    const distance = 50; // Base distance for animations
    
    switch (direction) {
      case 'up':
        return {
          ...baseProps,
          transform: inView ? 'translateY(0px)' : `translateY(${distance}px)`
        };
      case 'down':
        return {
          ...baseProps,
          transform: inView ? 'translateY(0px)' : `translateY(-${distance}px)`
        };
      case 'left':
        return {
          ...baseProps,
          transform: inView ? 'translateX(0px)' : `translateX(${distance}px)`
        };
      case 'right':
        return {
          ...baseProps,
          transform: inView ? 'translateX(0px)' : `translateX(-${distance}px)`
        };
      default:
        return baseProps;
    }
  };

  const springProps = useSpring(getAnimationProps());

  return (
    <animated.div ref={ref} style={springProps}>
      {children}
    </animated.div>
  );
};

export default AnimatedSection;